import {fromIterable, fromPromise} from "rxjs/internal-compatibility";
import {reduce, switchMap} from "rxjs/operators";
import {cloneDeep} from "lodash-es";
import ObjectCopyService from "external-services/object-copy-service/index";
import moment from 'moment';
import TrackingService from 'app/services/tracking/tracking.service';
import AdminService from "external-services/diary-admin-service/admin.service";
import BlockOutsService from "external-services/blockouts-service/blockouts.service";
import {ScheduleFilterService} from "external-services/schedule-filter-service/scheduleFilter.service";
import EventsService from 'app/services/events/events.service';
import GridSyncService from 'app/services/gridSync/gridSync.service';
import ScheduleLookupService from 'external-services/schedule-lookup-service/scheduleLookup.service';
import DateUtilsService from 'external-services/date-utils-service';
import LoginActions from "app/actions/login.actions";
import VenueActions, {VenueActionNames} from "app/actions/venue.actions";
import PouchLoadService from "external-services/pouch-load-service";
import PouchActions, {PouchDocType} from 'app/actions/pouch.actions';
const NS = 'ScheduleService'; // jshint ignore:line
// getDefualtDurartion and getSchedule move to scheduleLookupService
export default function ScheduleService(
  $rootScope, $q, $http, $filter, appConstants
) {
  "ngInject";

  var scheduleService = {};
  var scheduleLookUp = {};
  var allSchedules = null;

  scheduleService.bookingIntervals = [{
    value: 5,
    label: '5 min'
  }, {
    value: 10,
    label: '10 min'
  }, {
    value: 15,
    label: '15 min'
  }, {
    value: 20,
    label: '20 min'
  }, {
    value: 30,
    label: '30 min'
  }, {
    value: 45,
    label: '45 min'
  }, {
    value: 60,
    label: '1 hr'
  }, {
    value: 90,
    label: '1.5 hrs'
  }, {
    value: 120,
    label: '2 hrs'
  }, {
    value: 150,
    label: '2.5 hrs'
  }, {
    value: 180,
    label: '3 hrs'
  }, {
    value: 240,
    label: '4 hrs'
  }, {
    value: 360,
    label: '6 hrs'
  }, {
    value: 480,
    label: '8 hrs'
  }, {
    value: 720,
    label: '12 hrs'
  }];


  scheduleService.serviceColours = [{
    colour: 'Gray - default',
    code: 'booking-time'
  }, {
    colour: 'Violet',
    code: 'booking-time-yellow'

  }, {
    colour: 'Blue',
    code: 'booking-time-blue'
  }, {
    colour: 'Orange',
    code: 'booking-time-orange'
  }, {
    colour: 'Green',
    code: 'booking-time-green'
  }];


  scheduleService.init = function () {
    PouchActions.handlePouchSyncedDoctype(PouchDocType.schedule, () => scheduleService.clearCache());
    PouchActions.handlePouchSyncedDoctype(PouchDocType.event, () => scheduleService.clearLookUps());
    PouchActions.handlePouchSyncedDoctype(PouchDocType.blockout, () => scheduleService.clearLookUps());
    LoginActions.handleLogout(() => scheduleService.clearCache());
    VenueActions.handleVenueAction(VenueActionNames.VENUE_CHANGE, () => scheduleService.clearCache());

    // Load serviceTypes
    scheduleService.getServiceTypes().then(function (types) {

      // if takeAwayMode switched on, moves the takeAway serviceType options to the top
      var venue = AdminService.getVenue();
      if (venue && venue.isTakeAwayMode) {
        var index = types.findIndex(function (t) {
          return t.name === 'TakeAway';
        });
        var takeAwayOption = types.splice(index, 1);
        types.unshift(takeAwayOption[0]);
      }

      scheduleService.serviceTypes = types;
    });
  };

  scheduleService.clearCache = function () {
    scheduleLookUp = {};
    allSchedules = null;
    ScheduleFilterService.clearSchedulesByDayNum();
    ScheduleLookupService.clearCache();
  };

  scheduleService.clearLookUps = function () {
    scheduleLookUp = {};
  };

  scheduleService.addToCache = function (dateId, schedule) {
    scheduleLookUp[dateId] = {
      schedule: schedule,
      dateAdded: new Date()
    };
  };

  scheduleService.save = function (schedule) {

    TrackingService.trackEvent('Edit Schedule', {
      id: schedule._id,
      rev: schedule._rev
    });
    return $q.when(PouchLoadService.getDbLocal().put(schedule)).then(function (response) {
      // CLI-165: notify the Grid Sync API of the change
      GridSyncService.scheduleEdited(schedule._id || (response && response.id));
      return response;
    });
  };

  /**
   * Returns all the tags icons
   * @return {Promise}
   */
  scheduleService.getServiceTypes = function () {
    return $http.get('json/serviceTypes.json').then(function (response) {
      var serviceTypes = response.data;
      return serviceTypes;
    });
  };


  scheduleService.getScheduleLookUp = function () {
    return scheduleLookUp;
  };

  scheduleService.addDateInfoToSchedule = function (date, schedule) {
    schedule.services = scheduleService.orderServices(schedule.services, date);
    return scheduleService.addBlockouts(schedule, date).then(function (schedule) {
      return scheduleService.addEvents(schedule, date);
    }).then(function (schedule) {
      return scheduleService.addServicesSections(schedule, date);
    });
  };

  /**
   * Given a date will find all schedules that are active on and after the date
   * @param {Date} date
   */
  scheduleService.getAllSchedules = function (date) {
    if (!date) {
      return $q(function (resolve) {
        resolve(false);
      });
    }

    return $q.when(PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: 'schedule_day',
      endkey: 'schedule_day_\uffff',
    }).then(function (schedules) {
      // Check if the schedules are vaild
      var totalSchedules = schedules.rows.length;
      var vaildSchedules = [];
      var statAt = totalSchedules - 1;
      for (var i = statAt; i >= 0; i--) {
        var schedule = schedules.rows[i].doc;
        var idParts = schedule._id.split('_');
        var dateStr = idParts[idParts.length - 1];
        var vaildFrom = DateUtilsService.dateStrToDate(dateStr, '-');
        if (date.getTime() >= vaildFrom.getTime()) {
          vaildSchedules.push(schedule);
        }
      }
      return vaildSchedules;
    }));
  };

  /**
   * Add Blocksout to a schedule
   */
  scheduleService.addEvents = function (schedule, date) {
    return EventsService.getEventsOnDate(date).then(function (events) {
      if (!schedule.isOpen && events.length) {
        // you were orinally ment to be closedon this day
        // open and only have the event(s) listed
        schedule.isOpen = true;
        schedule.services = [];
      }
      schedule.services = schedule.services.concat(events);
      return schedule;
    });
  };

  /**
   * Add Blocksout to a schedule
   */
  scheduleService.addBlockouts = function (schedule, date) {
    // if (!schedule) {
    //   return Promise.resolve(null);
    // }
    return BlockOutsService.getBlockoutsOnDate(date).then(function (blockouts) {
      var idsFound = {};
      var sectionIds = schedule.services.map(function (service) {
        return service.sectionLayouts.map(function (sl) {
          return sl.sectionId;
        });
      }).reduce(function (a, b) {
        return a.concat(b);
      }, []).filter(function (id) {
        if (idsFound[id]) {
          return false;
        }
        idsFound[id] = true;
        return true;
      });

      for (var i = 0; i < blockouts.length; i++) {
        var blockout = blockouts[i];
        if (blockout.repeatType === appConstants.Blockout.RepeatTypes.Close) {
          blockout.blockedSections = sectionIds;
        }
      }
      schedule.blockouts = blockouts;
      return schedule;
    });
  };

  scheduleService.addServicesSections = function (schedule, date) {
    var scheduleServices = ObjectCopyService.angularSafeCopy(schedule.services);
    // loop over the servives
    var usedSectionIds = [];
    var services = [];
    var events = [];
    var service;
    var sectionLayout;
    var startMin, endMin, totalMin;

    for (var s = 0; s < scheduleServices.length; s++) {
      service = scheduleServices[s];
      // find out what sections are used
      var sectionLookUp = {};
      for (var i = service.sectionLayouts.length - 1; i >= 0; i--) {
        sectionLayout = service.sectionLayouts[i];
        sectionLookUp[sectionLayout.sectionId] = sectionLayout;
        if (usedSectionIds.indexOf(sectionLayout.sectionId) === -1) {
          usedSectionIds.push(sectionLayout.sectionId);
        } else {
        }
      }

      service.sectionLookUp = sectionLookUp;
      service.serviceIndex = s;
      // split the services
      if (service.type && service.type === 'event') {
        events.push(service);
      } else {
        services.push(service);
      }
    }

    var serviceLayouts = [];
    var sectionNotUsed;
    var sectionClosed;
    // create the sevice service layouts
    for (var f = 0; f < services.length; f++) {
      service = services[f];
      startMin = DateUtilsService.minsBetweenDates(date, service.startTime);
      endMin = DateUtilsService.minsBetweenDates(date, service.endTime);
      totalMin = (endMin - startMin);
      for (var j = usedSectionIds.length - 1; j >= 0; j--) {
        var sectionId = usedSectionIds[j];
        var sectionOpen = (service.sectionLookUp[sectionId]) ? true : false;
        sectionNotUsed = "";
        sectionClosed = "";
        try {
          sectionNotUsed = service.sectionLookUp[sectionId].sectionNotUsed;
          sectionClosed = service.sectionLookUp[sectionId].sectionClosed;
        }
        catch (err) {
          sectionNotUsed = false;
          sectionClosed = false;
        }
        serviceLayouts.push({
          serviceIndex: service.serviceIndex,
          serviceId: service._id,
          sectionId: sectionId,
          layoutId: (sectionOpen) ? service.sectionLookUp[sectionId].layoutId : false,
          sectionOpen: sectionOpen,
          sectionClosed: sectionClosed,
          sectionNotUsed: sectionNotUsed,
          name: service.name,
          startTime: service.startTime,
          endTime: service.endTime,
          startMin: startMin,
          endMin: endMin,
          totalMin: totalMin
        });




      }
    }

    for (var e = 0; e < events.length; e++) {
      var eventObj = events[e];
      var eventObjSectionIds = eventObj.sectionLayouts.map(function (sectionLayout) {
        return sectionLayout.sectionId;
      });
      startMin = DateUtilsService.minsBetweenDates(date, eventObj.startTime);
      endMin = DateUtilsService.minsBetweenDates(date, eventObj.endTime);
      totalMin = (endMin - startMin);

      var serviceLayout;
      // adjust the serviceLayouts
      for (var sl = 0; sl < serviceLayouts.length; sl++) {
        serviceLayout = serviceLayouts[sl];
        if (eventObjSectionIds.indexOf(serviceLayout.sectionId) !== -1) {

          // The serviceLayout used events section
          if (eventObj.startTime.getTime() <= serviceLayout.startTime.getTime() && eventObj.endTime.getTime() >= serviceLayout.endTime.getTime()) {
            // The event over laps the complete serviceLayouts
            // remove the entire serviceLayouts
            serviceLayout.remove = true;
          } else if (eventObj.startTime.getTime() > serviceLayout.startTime.getTime() && eventObj.endTime.getTime() < serviceLayout.endTime.getTime()) {
            // The events spits a serviceLayout modify the end time and add a new one
            var orgServiceLayout = ObjectCopyService.angularSafeCopy(serviceLayout);
            serviceLayout.endTime = eventObj.startTime;
            serviceLayout.endMin = startMin;
            serviceLayout.totalMin = (serviceLayout.endMin - serviceLayout.startMin);
            var newService = {
              serviceIndex: orgServiceLayout.serviceIndex,
              serviceId: orgServiceLayout.serviceId,
              sectionId: orgServiceLayout.sectionId,
              layoutId: orgServiceLayout.layoutId,
              sectionOpen: orgServiceLayout.sectionOpen,
              name: orgServiceLayout.name,
              startTime: eventObj.endTime,
              endTime: orgServiceLayout.endTime,
              startMin: endMin,
              sectionNotUsed: orgServiceLayout.sectionNotUsed,
              sectionClosed: orgServiceLayout.sectionClosed,
              endMin: orgServiceLayout.endMin,
              totalMin: (orgServiceLayout.endMin - endMin)
            };
            serviceLayouts.push(newService);
          } else if (eventObj.startTime.getTime() > serviceLayout.startTime.getTime() && eventObj.startTime.getTime() < serviceLayout.endTime.getTime()) {
            // The event start after the serviceLayout does
            // change the serviceLayout end time
            serviceLayout.endTime = eventObj.startTime;
            serviceLayout.endMin = startMin;
            serviceLayout.totalMin = (serviceLayout.endMin - serviceLayout.startMin);
          } else if (eventObj.endTime.getTime() < serviceLayout.endTime.getTime() && eventObj.endTime.getTime() > serviceLayout.startTime.getTime()) {
            // The event ends before the service does
            // change the serviceLayout start time
            serviceLayout.startTime = eventObj.endTime;
            serviceLayout.startMin = endMin;
            serviceLayout.totalMin = (serviceLayout.endMin - serviceLayout.startMin);
          }
        }
      }

      var newSectionLayouts = [];
      for (var sl1 = 0; sl1 < serviceLayouts.length; sl1++) {
        serviceLayout = serviceLayouts[sl1];
        if (!serviceLayout.remove) {
          newSectionLayouts.push(serviceLayout);
        }
      }
      serviceLayouts = newSectionLayouts;

      // insert events
      for (var n = eventObj.sectionLayouts.length - 1; n >= 0; n--) {
        sectionLayout = eventObj.sectionLayouts[n];
        sectionNotUsed = "";
        sectionClosed = "";
        try {
          sectionNotUsed = sectionLayout.sectionNotUsed;
          sectionClosed = sectionLayout.sectionClosed;
        }
        catch (err) {
          sectionNotUsed = false;
          sectionClosed = false;
        }
        // add the event serviceLayout
        serviceLayouts.push({
          serviceIndex: eventObj.serviceIndex,
          sectionId: sectionLayout.sectionId,
          serviceId: eventObj._id,
          layoutId: sectionLayout.layoutId,
          sectionOpen: (sectionLayout.layoutId),
          startTime: eventObj.startTime,
          endTime: eventObj.endTime,
          eventId: eventObj._id,
          name: eventObj.name,
          startMin: startMin,
          endMin: endMin,
          sectionNotUsed: sectionNotUsed,
          sectionClosed: sectionClosed,
          totalMin: totalMin
        });
      }



    }
    schedule.serviceLayouts = serviceLayouts;
    return schedule;
  };

  /**
   * Returns a schedule
   * @param {String} date
   */
  scheduleService.getScheduleById = function (id) {
    return $q.when(PouchLoadService.getDbLocal().get(id).then(function (schedule) {
      schedule.services = scheduleService.orderServices(schedule.services);
      return schedule;
    }));
  };

  /**
   * Return service times as Dates
   * @param  {Array} services A list of the services
   * @param  {Date} date The date you would like the service times to me created on
   */
  scheduleService.orderServices = function (services, date) {
    if (!date) {
      const timezoneId = AdminService.getVenueTimezoneId();
      date = DateUtilsService.getClearDate(null, timezoneId);
    }
    // make sure the services are in the correct order
    for (var i = services.length - 1; i >= 0; i--) {
      var service = services[i];
      service.startTime = DateUtilsService.timeToDate(service.startTime, date);
      service.lastBookingTime = DateUtilsService.timeToDate(service.lastBookingTime, date);
      service.endTime = DateUtilsService.timeToDate(service.endTime, date);
    }

    services = $filter('orderBy')(services, 'startTime');
    return services;
  };

  /**
   * Returns all schedules for the days of the week.
   * This will only omit historical data and only show 1 object per day (unlike `scheduleService.getSchedules`,
   * which includes historical data as well).
   * @param {Date} date
   */
  scheduleService.getDaySchedules = function () {
    return $q.when(PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: 'schedule_day',
      endkey: 'schedule_day' + '\uffff',
    }).then(function (schedules) {
      var schedulesByDay = [null, null, null, null, null, null, null];
      // Find the latest versions of each schedule
      // console.log('schedules.rows', schedules.rows.length)
      for (var i = schedules.rows.length - 1; i >= 0; i--) {
        var schedule = schedules.rows[i].doc;
        schedule.services = scheduleService.orderServices(schedule.services);
        var idParts = schedule._id.split('_');
        var dateStr = idParts[idParts.length - 1];
        schedule.vaildFrom = DateUtilsService.dateStrToDate(dateStr, '-');
        // remove the date from the id
        if (!schedulesByDay[schedule.dayNum] || (schedule.vaildFrom > schedulesByDay[schedule.dayNum].vaildFrom.getTime())) {
          // add the latest schedule from this id to the look up
          schedulesByDay[schedule.dayNum] = schedule;
        }
      }
      return schedulesByDay;
    }));
  };

  scheduleService.getAllDaySchedules = function () {
    return $q.when(PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: 'schedule_day',
      endkey: 'schedule_day' + '\uffff'
    }));
  };

  scheduleService.deleteSchedule = function (schedule) {
    return $q.when(PouchLoadService.getDbLocal().remove(schedule));
  };

  scheduleService.addIdsToServices = function () {
    return $q.when(PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: 'schedule',
      endkey: 'schedule\uffff',
    }).then(function (schedules) {
      var updatedScedules = [];
      for (var i = schedules.rows.length - 1; i >= 0; i--) {
        var schedule = schedules.rows[i].doc;
        var schedulesUpdated = false;
        for (var s = schedule.services.length - 1; s >= 0; s--) {
          var service = schedule.services[s];
          if (!service._id) {
            service._id = PouchLoadService.getNewId(['service']);
            schedulesUpdated = true;
          }
        }
        if (schedulesUpdated) {
          updatedScedules.push(schedule);
        }
      }
      return updatedScedules;
    }).then(function (updatedScedules) {
      return PouchLoadService.getDbLocal().bulkDocs(updatedScedules);
    }));
  };

  scheduleService.getSchedulesDateLookUp = function (startDate, endDate) {
    var dates = [startDate];
    if (endDate) {
      startDate = moment(startDate);
      endDate = moment(endDate);
      while (startDate < endDate) {
        startDate.add(1, 'days');
        dates.push(startDate.toDate());
      }
    }

    var schedulesLookUpPromise = Promise.resolve();
    var schedulesLookUp = [];

    for (let date of dates) {
      schedulesLookUpPromise = schedulesLookUpPromise.then(() => {
        return ScheduleLookupService.getSchedule(date).then(function (schedule) {
          schedulesLookUp[$filter('date')(date, 'yyyy-MM-dd')] = schedule;
        });
      });
    }

    schedulesLookUpPromise = schedulesLookUpPromise.then(() => schedulesLookUp);

    return schedulesLookUpPromise;
  };

  /**
   * Returns booking/menu options that are still active in the schedule.
   * Note: there is a similar function in `eventsService` called `getActiveMenuOptions`.
   */
  scheduleService.getActiveMenuOptions = () => {
    return fromPromise(
      scheduleService.getDaySchedules()
    )
    .pipe(
      switchMap(schedules => {
        return fromIterable(
          schedules.reduce((acc, s) => {
            if (s.isOpen) {
              acc = acc.concat(s.services);
            }
            return acc;
          }, [])
        );
      }),
      reduce((acc, service) => {
        if (service.paymentDetails && service.paymentDetails.menuOptions) {
          // extract menuOptions ids
          acc = acc.concat(service.paymentDetails.menuOptions);
          // filter out duplicate
          acc = acc.filter((menuOptionId, i) => acc.indexOf(menuOptionId) === i)
        }
        return acc;
      }, [])
    );
  }


  /**
   * Retrieves intervals from a service that overlaps with a booking start time and duration
   * @param booking - IBooking
   * @param service - IDiaryService
   * @returns IServiceInterval[]
   */
  scheduleService.getIntervalsByBooking = (booking, service, addDateTimeToIntervals = false) => {

    if (!service || !service.intervalsCustom || !booking) {
      return [];
    }

    const {duration, time} = booking;
    let {bookingMin} = booking;

    // get the start of the day as a date, to work out minutes of current day
    const dateStartOfDay = DateUtilsService.getStartOfDay(time, true);
    const intervals = [];

    if (typeof bookingMin === 'undefined') {
      bookingMin = DateUtilsService.minsBetweenDates(dateStartOfDay, time);
    }

    service.intervalsCustom.forEach(int => {

      // construct a new date from am/pm time
      const intTime = scheduleService.getDateFromIntervalStringTime(int, dateStartOfDay, false);

      // push the interval if booking time (in minutes) overlaps interval
      const minsOfDay = intTime.diff(dateStartOfDay, 'minutes');

      if (minsOfDay >= bookingMin && minsOfDay < bookingMin + duration) {
        const interval = cloneDeep(int);
        if (addDateTimeToIntervals) {
          interval.time = intTime.toDate();
        }
        intervals.push(interval);
      }
    });

    return intervals;
  }

  /**
   * Converts am/pm interval string to a Date object.
   * @param intv {String} - time as am/pm string. Eg '03:45 pm'
   * @param dateStartOfDay {Date} - Use `DateUtilsService.getStartOfDay(time, true)` to get `dateStartOfDay`
   * @param returnAsDate {Boolean} - If true, will return Date object, if false a Moment object
   * @return {Date} - interval as a Date object
   */
  scheduleService.getDateFromIntervalStringTime = (int, dateStartOfDay, returnAsDate) => {
    const isPm = int.times.indexOf(' pm') !== -1; // use pm to work out if we need to add 12 hours
    const hourNum = parseInt(int.times.split(':')[0], 10) + (isPm ? 12 : 0); // hours as a number
    const minNum = parseInt(int.times.split(':')[1].split(' ')[0], 10); // minutes as a number

    // construct a new date from am/pm time
    const intTime = moment(dateStartOfDay);
    intTime.set('hour', hourNum);
    intTime.set('minute', minNum);

    if (returnAsDate) {
      return intTime.toDate();
    }

    return intTime;
  }

  /**
   * Returns a list of bookings that overlap with the primaryBooking
   * @param primaryMin {Date} - start time of booking to compare times
   * @param primaryDuration {number} - duration in minutes of booking to compare times with
   * @param listOfBookings {IBooking[]} - list of bookings to loop though and match overlapping times with
   * @returns {IBooking[]} - list of matched bookings
   */
  scheduleService.getBookingsWithOverlappingTimes = (primaryTime, primaryDuration, listOfBookings) => {
    if (!listOfBookings || !listOfBookings.length) {
      return [];
    }

    const primaryStart = moment(primaryTime);
    const primaryEnd = moment(primaryTime).add(primaryDuration, 'minutes');

    const result = [];
    listOfBookings.forEach(b => {

      const bookingStart = moment(b.time);
      const bookingEnd = moment(b.time).add(b.duration, 'minutes');

      const matchesWhenStartsOnOrAfter = bookingStart.isSameOrAfter(primaryStart)
        && bookingStart.isBefore(primaryEnd);

      const matchesWhenStartsBefore = bookingStart.isBefore(primaryStart)
        && bookingEnd.isAfter(primaryStart);

      if (matchesWhenStartsOnOrAfter || matchesWhenStartsBefore) {
        result.push(b);
      }
    });

    return result;
  }

  return scheduleService;
}
